import Vue from 'vue'

export default {
	createReport (body) {
		return Vue.http.post('leadership/dashboard/search', body)
	}
}
